import React,{useEffect} from 'react'
import FiveDTimer from './fiveDTimer'

const Ticket = ({ activeTimer,setCall, activeT }) => {
  return (
      <div className='w-full p-4'>

      <div className='w-full bg-white rounded-lg'>

        <div className='flex justify-between items-center p-2'>
            <p className='text-sm'>Game Results</p>
            <div className='flex justify-center items-center '>
                <p className='flex justify-center items-center  w-[35px] h-[35px] text-center rounded-full border border-black'>6</p>
                <p className='flex justify-center items-center  w-[35px] h-[35px] text-center rounded-full border border-black'>6</p>
                <p className='flex justify-center items-center  w-[35px] h-[35px] text-center rounded-full border border-black'>0</p>
                <p className='flex justify-center items-center  w-[35px] h-[35px] text-center rounded-full border border-black'>0</p>
                <p className='flex justify-center items-center  w-[35px] h-[35px] text-center rounded-full border border-black'>5</p>
                <p className='flex justify-center items-center  text-center'>=</p>
                <p className='flex justify-center items-center text-white bg-red-600 w-[35px] h-[35px] text-center rounded-full border'>17</p>
            </div>
        </div>
    <div className='flex  justify-between items-center p-2 w-full my-2'>
        <div className='flex flex-col'>
          <p className=' px-1'>Last Draw</p>
          <p className='font-bold'>2501151593</p>
        </div>
        <div className='flex flex-col'>
          <p className=''>Time remaining</p>
          <p ><FiveDTimer setCall={setCall} activeT={activeT}/></p>
        </div>
      </div>
      </div>
      </div>
  )
}

export default Ticket